const splitNotificationBody = (body) =>
  String(body || '')
    .split(/\n+/)
    .map((line) => line.trim())
    .filter(Boolean);

const normalizeComparableText = (value) =>
  String(value || '')
    .toLowerCase()
    .replace(/[.]+$/g, '')
    .replace(/\s+/g, ' ')
    .trim();

const isSameNotificationText = (a, b) => {
  const left = normalizeComparableText(a);
  const right = normalizeComparableText(b);
  return Boolean(left && right && left === right);
};

export const getNotificationDisplay = (notification, intl) => {
  const extra = notification?.extra_info || {};
  const bodyLines = splitNotificationBody(notification?.body);

  if (notification?.category === 'group_invitation_notification') {
    const inviterName = extra.inviter_name || extra.inviterName || extra.user_name || extra.full_name;
    const groupName = extra.group_name || extra.groupName || extra.name;
    const generatedTitle =
      inviterName && groupName
        ? intl.formatMessage(
            {
              id: 'notifications.group_invite.title',
              defaultMessage: '{inviterName} invited you to join {groupName}',
            },
            { inviterName, groupName },
          )
        : null;
    const rawTitle = notification?.title || '';
    const title =
      generatedTitle ||
      (rawTitle && rawTitle !== 'Group invitation' ? rawTitle : bodyLines[0] || rawTitle);
    const invitationMessage =
      extra.invitation_message || extra.invitationMessage || bodyLines.slice(1).join('\n');
    const body =
      invitationMessage && !isSameNotificationText(invitationMessage, title)
        ? invitationMessage
        : '';

    return {
      eyebrow: intl.formatMessage({
        id: 'notifications.group_invite.eyebrow',
        defaultMessage: 'Group invitation',
      }),
      title,
      body,
    };
  }

  if (notification?.category === 'room_invitation_notification') {
    const inviterName = extra.inviter_name || extra.inviterName || extra.user_name || extra.full_name;
    const roomName = extra.room_name || extra.roomName || extra.name;
    const generatedTitle =
      inviterName && roomName
        ? intl.formatMessage(
            {
              id: 'notifications.room_invite.title',
              defaultMessage: '{inviterName} invited you to join {roomName}',
            },
            { inviterName, roomName },
          )
        : null;
    const rawTitle = notification?.title || '';
    const title =
      generatedTitle ||
      (rawTitle && rawTitle !== 'Room invitation' ? rawTitle : bodyLines[0] || rawTitle);
    const invitationMessage =
      extra.invitation_message || extra.invitationMessage || bodyLines.slice(1).join('\n');

    return {
      eyebrow: intl.formatMessage({
        id: 'notifications.room_invite.eyebrow',
        defaultMessage: 'Room invitation',
      }),
      title,
      body:
        invitationMessage && !isSameNotificationText(invitationMessage, title)
          ? invitationMessage
          : '',
    };
  }

  if (notification?.category === 'group_join_request_notification') {
    const requesterName = extra.requester_name || extra.requesterName || extra.user_name || extra.full_name;
    const groupName = extra.group_name || extra.groupName || extra.name;
    const generatedTitle =
      requesterName && groupName
        ? intl.formatMessage(
            {
              id: 'notifications.group_join_request.title',
              defaultMessage: '{requesterName} requested to join {groupName}',
            },
            { requesterName, groupName },
          )
        : null;

    return {
      eyebrow: intl.formatMessage({
        id: 'notifications.group_join_request.eyebrow',
        defaultMessage: 'Group join request',
      }),
      title: generatedTitle || notification?.title || '',
      body: notification?.body || '',
    };
  }

  return {
    eyebrow: null,
    title: notification?.title || '',
    body: notification?.body || '',
  };
};

export default getNotificationDisplay;
